import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { AuthenticationService } from './authenticationService';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { AppConfigService } from './appConfigService';
import { HTTP } from '@ionic-native/http/ngx';
import { DialogService } from './dialog.service';
import { APPCONFIG } from '../_store';

@Injectable({
  providedIn: 'root'
})
export class AppInfoService {

  versionInfo: any = {};


  constructor(
    private commonService: CommonService,
    private authenticationService: AuthenticationService,
    private appConfig: AppConfigService,
    private appVersion: AppVersion,
    private dialogService: DialogService,
    private http: HTTP
  ) {
  }

  private getAppVersion() {
    let infoFetched = 0;
    const setInfo = (key, val, resolve) => {
      infoFetched += 1;
      this.versionInfo[key] = val;
      if (infoFetched >= 4) {
        resolve(this.versionInfo);
      }
    }
    return new Promise((resolve, reject) => {
      if (!this.commonService.isCurrentPlatformWeb()) {
        this.appVersion.getAppName().then(str => {
          setInfo('appName', str, resolve);
        });
        this.appVersion.getPackageName().then(str => {
          setInfo('packageName', str, resolve);
        });
        this.appVersion.getVersionCode().then(str => {
          //TODO
          //TEMPORARY code, till version code for iOS and android are same
          setInfo('versionCode', str, resolve);
        });
        this.appVersion.getVersionNumber().then(str => {
          setInfo('versionNo', str, resolve);
        });
      } else {
        this.versionInfo.versionNo = this.appConfig.appVersion;
        resolve(this.versionInfo);
      }
    });

  }

  checkUpdateRequired() {
    return new Promise((resolve, reject) => {
      const skipUpdateCheck = false;
      if (this.commonService.isCurrentPlatformWeb() || skipUpdateCheck) {
        resolve(false);
      } else {
        this.getAppVersion().then((versionData: any) => {
          const packageName = versionData.packageName;
          const versionCode = versionData.versionCode;
          // this.http.get(this.appConfig.urls.auto_update, {}, {}).then(data => {
          this.authenticationService.getAppVersion().subscribe(data => {
            try {
              console.log(data);
              if (data) {
                const appVersionStrKey = this.commonService.isCurrentPlatformiOS() ? 'ios' : 'android';
                const serverVersionStr = (data[appVersionStrKey] || {}).version || '';
                const serverVersionCode = parseInt((serverVersionStr.replace(/\./g,'')) || '', 10);
                const appUrl = (data[appVersionStrKey] || {}).appUrl || '';
                if (!isNaN(serverVersionCode) && ((serverVersionCode > versionCode))) {
                  resolve({ update: true, packageName, serverVersionCode,  versionCode, appUrl, serverVersionStr});
                } else {
                  resolve(false);
                }
              } else {
                resolve(false);
              }
            } catch (err) {
              resolve(false);
            }
          }, () => {
            resolve(false);
          });
        });
      }
    });
  }

  processAppUpdate(updateData) {
    this.dialogService.hideWaitMessage();
    this.authenticationService.logout();
    const msg = `There is a newer version (${updateData.serverVersionStr}) of this application available, please update your app. If you cannot update it please use our web app https://prod.payex.live/`;
    this.dialogService.showInfoAlert(msg).then(() => {
      if (updateData && updateData.appUrl) {
        window.open(updateData.appUrl, `_system`, `location=yes`);
        setTimeout(() => {
          navigator['app'].exitApp();
        }, 500);
      }
    });
  }

  // if versionStr 0.0.3 should return (0 * 100 + 0 * 10 + 3)
  private getVersionNo(versionStr) {
    const versionArr = versionStr.toString().split('.');
    return versionArr.map((n, Index) => {
      return parseInt(n) * (versionArr.length - Index)
    }).reduce((total, n) => {
      return total + n
    }, 0);
  }

  getAppHelpUrl() {
    const fileName = this.appConfig.appName === 'Freepay' ? '_fis' : '_' + this.appConfig.appName;
    return `/static-files/help${fileName}.html`;
  }

  getAppName() {
    return this.appConfig.appName === 'Freepay' ? '' : this.appConfig.appName;
  }



}
